import { render } from "./clientTypeAdd.vue?vue&type=template&id=3b767a6b&scoped=true"
import script from "./clientTypeAdd.vue?vue&type=script&lang=js"
export * from "./clientTypeAdd.vue?vue&type=script&lang=js"

import "./clientTypeAdd.vue?vue&type=style&index=0&id=3b767a6b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b767a6b"]])

export default __exports__